export const FLAGSMITH_KEYS = {
  /**
   * This will decide whether user will be shown new sequence or old sequence
   */
  SHOW_NEW_FEATURE_V1: 'show_new_feature_v1',
  /**
   * This will decide wheter to show whole new EzFile UI or not
   */
  EZ_FILE: 'fe_ez_file_new_ui',
} as const;
